import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from 'axios';
import qs from 'qs';
import { useUserStoreWidthOut } from '../store/modules/user';

import router from '@/router';

import { ElMessage, ElNotification } from 'element-plus';
import { getToken, getFPLToken } from '@/utils/auth';

const _baseURL = location.origin;

const codeMessage: any = {
  200: '服务器成功返回请求的数据',
  204: '没有返回数据',
  301: '页面重定向',
  400: '客户端发生错误',
  401: 'token失效，请重新登录',
  403: '服务器理解请求客户端的请求，但是拒绝执行此请求',
  404: '发出的请求针对的是不存在的记录',
  500: '服务器发生错误，请检查服务器',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时',
};
export interface IRequest {
  get(url: string, data?: any, config?: any): Promise<any>;
  post(url: string, data?: any, config?: any): Promise<any>;
}

class Request implements IRequest {
  public async get(url: string, data: any, config: any): Promise<any> {
    const conf = Object.assign({ params: data }, config);
    const response = await this.createAxiosInstance().get(url, conf);
    return response;
  }
  public async post(url: string, data: any, config: any): Promise<any> {
    const response = await this.createAxiosInstance().post(url, data, config);
    return response;
  }
  private createAxiosInstance(): AxiosInstance {
    const instance = axios.create({
      baseURL: `${_baseURL}`,

      // timeout: 5000,
    });
    instance.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        const userStore = useUserStoreWidthOut();
        // 处理请求数据以及配置
        if (config.method === 'get') {
          // 将数组参数序列化
          config.paramsSerializer = (params: any) => {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          };
          if (config.params) {
            Object.keys(config.params).map((element) => {
              if (config.params[element] === '') {
                delete config.params[element];
              }
            });
          }
        }
        const token = getToken() || userStore.tempToken;
        if (
          config.baseURL &&
          config.url?.startsWith('http') &&
          !config.url?.includes(config.baseURL)
        ) {
          // 跨域时不添加header,否则CORS会失效
        } else {
          if (token) {
            config.headers!['X-Otwb-Passport-Session'] = token;
          }
        }

        if (config.baseURL && config.url?.includes('/fpl-api/')) {
          if (token) {
            config.headers!['Authorization'] = `Bearer ${getFPLToken()}`;
          }
        }

        return config;
      },
      (error: AxiosError) => {
        return Promise.reject(error);
      }
    );
    instance.interceptors.response.use(
      (response: AxiosResponse) => {
        // 对响应数据进行操作
        if (response.status == 200) {
          if (response.data.result === 'err') {
            ElMessage({
              message: response.data.message,
              type: 'error',
            });
            return Promise.reject(response.data.message);
          } else if (response.data.message) {
            // IWMS的看板接口默认返回查询成功
            if (!response.request?.responseURL.includes('/wms-web/bdweb/')) {
              ElMessage({
                message: response.data.message,
                type: 'success',
              });
            }
          }
        }
        if (
          response.data &&
          typeof response.data === 'object' &&
          'data' in response.data
        ) {
          return response.data.data;
        } else if (response.data) {
          return response.data;
        } else {
          return response;
        }
      },
      (error: AxiosError) => {
        const userstore = useUserStoreWidthOut();
        if (error.response) {
          const responseCode = error.response.status;
          switch (responseCode) {
            case 301:
              if (error.response.data.data.redirectUrl) {
                window.open(error.response.data.data.redirectUrl, '_self');
              }
              break;
            case 401:
              userstore.resetState();
              router.replace({ name: 'login' });
              break;
            default:
              showReponseError(responseCode);
              break;
          }
        } else {
          ElNotification({
            message: '网关超时',
            title: '请检查网络状态',
            type: 'error',
          });
        }
        return Promise.reject(error);
      }
    );
    return instance;
  }
}
const showReponseError = (status: number) => {
  // message.error(codeMessage[status]);
  ElNotification({
    title: `${codeMessage[status]}`,
    message: `状态码为${status}`,
    type: 'error',
  });
};

const requestService: IRequest = new Request();
export default requestService;
